<template>
  <div id="app" :style="{'background': $route.name === 'home' ? '#fff' : '#F3F3F3'}">
    <!-- <router-view /> -->
    <keep-alive v-if="keepAlive">
      <router-view :key="key" />
    </keep-alive>
    <router-view v-else />
  </div>
</template>

<script>
// import { Debounce } from '@/utils/debounce'

export default {
  name: 'App',
  // 暴露 reload 方法，方便组件调用
  computed: {
    keepAlive() {
      if (this.$route.matched[0] && this.$route.matched[0].path === '/screen') {
        return this.$route.meta.keepAlive
      }
      return false
    },
    key() {
      return this.$route.fullPath.split('&m=')[0]
    }
  },
  mounted() {
    // const getWindowInfo = () => {
    //   const screenWidth = window.innerWidth
    //   var zoom = (screenWidth / 1920).toFixed(2)
    //   document.body.style.zoom = zoom > 0.8 ? zoom : 0.8
    // }
    // const cancalDebounce = Debounce(getWindowInfo, 500)
    // window.addEventListener('resize', cancalDebounce)

    // getWindowInfo()

    function checkIE() {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  methods: {
  }

}
</script>
<style lang="scss">
body {
  font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
}
#app {
  // min-width: 1000px;
}
// .page-header{
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }
// // ::-webkit-scrollbar{
// //   width: 5px;
// //   height: 5px;
// // }
// // ::-webkit-scrollbar-thumb{
// //   border-radius: 1em;
// //   background-color: rgba(50,50,50,.3);
// // }
// // ::-webkit-scrollbar-track{
// //   border-radius: 1em;
// //   background-color: rgba(50,50,50,.1);
// // }
// // 一级标题
// .first-title {
//   font-size: 18px;
//   color: #333333;
//   line-height: 24px;
// }
// // 二级标题
// .second-title {
//   font-size: 16px;
//   font-weight: bold;
//   color: #333333;
//   line-height: 22px;
//   margin-top: 30px;
// }
// // 查询条件标题
// .query-title {
//   font-size: 18px;
//   color: #333333;
//   line-height: 24px;
//   margin-bottom: 16px;
//   font-weight: bold;
// }
// // 返回按钮颜色
// .back-btn {
//   background: #E8E8E8 !important;
//   color: #333 !important;
// }
// .back-btn:hover {
//   background: #F0F0F0 !important;
//   color: #333 !important;
//   border-color: #F0F0F0 !important;
// }
// .small-dialog {
//   .el-dialog {
//     width: 500px!important;
//     height: 418px!important;
//   }
// }
// .my-primary {
//   background: #1C233B!important;
//   font-size: 14px;
//   font-weight: 400;
//   color: #FFFFFF;
//   border: 0;
//   padding: 13px 28px;
// }
// .dialog-footer {
// 一级标题
// .first-title {
//   font-size: 18px;
//   color: #333333;
//   line-height: 24px;
// }
// // 二级标题
// .second-title {
//   font-size: 16px;
//   font-weight: bold;
//   color: #333333;
//   line-height: 22px;
//   margin-top: 30px;
// }
// // 查询条件标题
// .query-title {
//   font-size: 18px;
//   color: #333333;
//   line-height: 24px;
//   margin-bottom: 16px;
//   font-weight: bold;
// }
// // 返回按钮颜色
// .back-btn {
//   background: #E8E8E8 !important;
//   color: #333 !important;
// }
// .back-btn:hover {
//   background: #F0F0F0 !important;
//   color: #333 !important;
//   border-color: #F0F0F0 !important;
// }
// .small-dialog {
//   .el-dialog {
//     width: 500px!important;
//     height: 418px!important;
//   }
// }
// .my-primary {
//   background: #1C233B!important;
//   font-size: 14px;
//   font-weight: 400;
//   color: #FFFFFF;
//   border: 0;
//   padding: 13px 28px;
// }
// .dialog-footer {
//   text-align: center;
//   .add-btn.el-button--primary {
//     width: 144px;
//   }
//   .add-btn.el-button {
//     width: 144px;
//   }
// }
// // el-upload
// .el-upload-list--picture-card .el-upload-list__item {
//   width: 130px;
//   height: 130px;
//   border-radius: 4px;
//   border: 1px solid #D6D7DD;
//   margin: 0 20px 10px 0;
// }
// .el-upload--picture-card {
//   width: 130px;
//   height: 130px;
//   line-height: 130px;
//   border-radius: 4px;
//   border: 1px solid #D6D7DD;
// }
// .el-upload--picture-card .el-button {
//   width: 85px;
//   padding: 0;
//   text-align: center;
//   height: 36px;
//   background: #1C233B;
//   border-radius: 4px;
//   border: none;
// }
// .el-upload--picture-card:hover {
//   border: none;
// }
// // el-form
// .el-form--label-top .el-form-item__label {
//   font-size: 14px;
//   font-weight: 400;
//   color: #333333;
//   line-height: 16px;
//   margin-bottom: 12px;
//   padding: 0;
// }
// .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
//   content: '';
//   color: #F56C6C;
//   margin-right: 0;
// }
// .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:after {
//   content: '*';
//   color: #F56C6C;
//   margin-left: 4px;
// }
// // loading遮罩
// .el-loading-mask {
//   background: #F7F7F7;
// }
// // 面包屑
// .el-breadcrumb__inner.is-link, .el-breadcrumb__inner a {
//   color: #666666!important;
// }
// .app-breadcrumb.el-breadcrumb .no-redirect {
//   color: #666666!important;
// }
// // switch
// .el-switch__core {
//   border: #999999 2px solid!important;
//   background: transparent!important;
// }
// .el-switch__core:after {
//   width: 10px;
//   height: 10px;
//   background: transparent;
//   border: 2px solid #999999;
//   top: 3px;
//   left: 5px;
// }
// .el-switch.is-checked .el-switch__core::after {
//   margin-left: -15px!important;
//   border: 2px solid #2461D9;
// }
// /** el-dialog */
// .el-dialog__header > .el-dialog__headerbtn {
//   top: 12px;
// }
// .el-dialog__header >.el-dialog__title{
//   width: 103px;
//   height: 22px;
//   font-size: 16px;
//   font-weight: 500;
//   color: #333333;
//   line-height: 22px;
// }
// .v-modal {
//   background: rgba(42,47,77, 0.8)!important;
// }
// .el-image-viewer__wrapper {
//   z-index: 2500!important;
// }
.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left!important;

  .el-dialog {
    // width: 700px!important;
    background: #ffffff;
    border-radius: 21px;
    margin: 0!important;
    .el-dialog__header{
      padding: 30px 30px 0 30px;
    }
    .el-dialog__body{
      padding: 30px 40px 20px;
      max-height: 700px;
      overflow: auto;
    }
  }
}
// /**element pagination  */
// .el-pagination__sizes .el-input__inner {
//   height: 36px;
//   margin-top: 4px;
// }
// .el-pagination__total {
//   margin-top: 8px;
// }
// .el-pagination.is-background .btn-next {
//   margin: 0 0 0 20px;
// }
// .el-pagination.is-background .btn-prev {
//   margin: 0 20px 0 0;
// }
// .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
//   width: 90px;
//   height: 44px;
//   background: #FFFFFF;
//   border-radius: 10px;
//   font-weight: 400;
// }
// .el-pagination.is-background .btn-next span, .el-pagination.is-background .btn-prev span {
//   line-height: 28px;
//   font-size: 14px;
//   color: #666666;
// }
// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   min-width: 44px;
//   width: auto;
//   height: 44px;
//   background: #2461D9;
//   border-radius: 10px;
//   font-size: 14px;
//   font-weight: 400;
//   color: #FFFFFF;
//   line-height: 44px;
// }
// .el-pagination.is-background .el-pager li {
//   min-width: 44px;
//   width: auto;
//   height: 44px;
//   border-radius: 10px;
//   border: 1px solid #E5E5E5;
//   background: transparent;
//   font-size: 14px;
//   font-weight: 400;
//   color: #9A9A9A;
//   line-height: 44px;
// }
// .el-pagination {
//   display: flex;
//   justify-content: flex-end;
//   margin-top: 30px;
// }
// /**element table */
.el-table {
  color: #333333;
}
// .el-table::before {
//   height: 0;
// }
// .el-table .el-table__header tr, .el-table .el-table__body tr {
//   background: transparent!important;
// }
// .el-table .el-table__header {
//   border-top: 1px solid #EAEAEC;
// }
// .el-table .el-table__header th {
//   line-height: 20px;
//   height: 54px;
//   padding: 0;
//   background: transparent!important;
// }
// .el-table .el-table__body td {
//   line-height: 20px;
//   height: 56px;
//   padding: 0;
//   background: transparent!important;
//   border-bottom: 1px solid #EAEAEC;
// }
// .el-table .el-table__header th .icon, .el-table .el-table__body td .icon {
//   color: #999999;
//   font-size: 18px;
//   margin-right: 14px;
//   cursor: pointer;
// }
// .el-table .el-table__body .el-table__row--level-0 td {  // 一级table, 可以点开的，，，
//   background: transparent!important;
//   border-bottom: 2px solid #F7F7F7;
// }
// .el-table .el-table__body tr:hover {
//   box-shadow: 0px 0px 10px 0px rgba(228, 228, 228, 0.5);
// }
// .el-table .el-table__body tr:hover>td {
//   border-bottom: 0;
// }
// .el-table--enable-row-hover .el-table__body-wrapper .el-table__body .el-table__row--level-0:hover>td {   // 一级table
//   box-shadow: 0 0px 0px #ccc;
//   border-radius: 0;
//   border-bottom: 2px solid #F7F7F7;
// }
// .el-table--enable-row-hover .el-table__body tr:hover>td .el-icon-edit-outline, .el-table--enable-row-hover .el-table__body tr:hover>td .el-icon-circle-plus-outline {
//   color: #2461D9;
// }
// .el-table--enable-row-hover .el-table__body tr:hover>td .el-icon-remove-outline {
//   color: #FF754C;
// }
// .el-table .el-table__header .cell{
//   font-size: 14px;
//   font-weight: 400;
//   color: #989898;
// }
// .el-table .el-table__body .cell{
//   font-size: 14px;
//   font-weight: 400;
//   color: #333333;
// }
// .el-table__expand-icon {
//   transform-origin: 10px 10px;
//   margin-right: 11px!important;
//   width: 20px;
//   height: 20px;
//   line-height: 20px;
//   text-align: center;
//   .add-btn.el-button--primary {
//     width: 144px;
//   }
//   .add-btn.el-button {
//     width: 144px;
//   }
// }
// // el-upload
// .el-upload-list--picture-card .el-upload-list__item {
//   width: 130px;
//   height: 130px;
//   border-radius: 4px;
//   border: 1px solid #D6D7DD;
//   margin: 0 20px 10px 0;
// }
// .el-upload--picture-card {
//   width: 130px;
//   height: 130px;
//   line-height: 130px;
//   border-radius: 4px;
//   border: 1px solid #D6D7DD;
// }
// .el-upload--picture-card .el-button {
//   width: 85px;
//   padding: 0;
//   text-align: center;
//   height: 36px;
//   background: #1C233B;
//   border-radius: 4px;
//   border: none;
// }
// .el-upload--picture-card:hover {
//   border: none;
// }
// // el-form
// .el-form--label-top .el-form-item__label {
//   font-size: 14px;
//   font-weight: 400;
//   color: #333333;
//   line-height: 16px;
//   margin-bottom: 12px;
//   padding: 0;
// }
// .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
//   content: '';
//   color: #F56C6C;
//   margin-right: 0;
// }
// .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:after {
//   content: '*';
//   color: #F56C6C;
//   margin-left: 4px;
// }
// // loading遮罩
// .el-loading-mask {
//   background: #F7F7F7;
// }
// // 面包屑
// .el-breadcrumb__inner.is-link, .el-breadcrumb__inner a {
//   color: #666666!important;
// }
// .app-breadcrumb.el-breadcrumb .no-redirect {
//   color: #666666!important;
// }
// // switch
// .el-switch__core {
//   border: #999999 2px solid!important;
//   background: transparent!important;
// }
// .el-switch__core:after {
//   width: 10px;
//   height: 10px;
//   background: transparent;
//   border: 2px solid #999999;
//   top: 3px;
//   left: 5px;
// }
// .el-switch.is-checked .el-switch__core::after {
//   margin-left: -15px!important;
//   border: 2px solid #2461D9;
// }
// /** el-dialog */
// .el-dialog__header > .el-dialog__headerbtn {
//   top: 12px;
// }
// .el-dialog__header >.el-dialog__title{
//   width: 103px;
//   height: 22px;
//   font-size: 16px;
//   font-weight: 500;
//   color: #333333;
//   line-height: 22px;
// }
// .v-modal {
//   background: rgba(42,47,77, 0.8)!important;
// }
// .el-image-viewer__wrapper {
//   z-index: 2500!important;
// }
// .el-dialog__wrapper {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   text-align: left!important;

//   .el-dialog {
//     // width: 700px!important;
//     background: #ffffff;
//     border-radius: 21px;
//     margin: 0!important;
//     .el-dialog__header{
//       padding: 30px 30px 0 30px;
//     }
//     .el-dialog__body{
//       padding: 30px 40px 20px;
//       max-height: 700px;
//       overflow: auto;
//     }
//   }
// }
// /**element pagination  */
// .el-pagination__sizes .el-input__inner {
//   height: 36px;
//   margin-top: 4px;
// }
// .el-pagination__total {
//   margin-top: 8px;
// }
// .el-pagination.is-background .btn-next {
//   margin: 0 0 0 20px;
// }
// .el-pagination.is-background .btn-prev {
//   margin: 0 20px 0 0;
// }
// .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
//   width: 90px;
//   height: 44px;
//   background: #FFFFFF;
//   border-radius: 10px;
//   font-weight: 400;
// }
// .el-pagination.is-background .btn-next span, .el-pagination.is-background .btn-prev span {
//   line-height: 28px;
//   font-size: 14px;
//   color: #666666;
// }
// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   min-width: 44px;
//   width: auto;
//   height: 44px;
//   background: #2461D9;
//   border-radius: 10px;
//   font-size: 14px;
//   font-weight: 400;
//   color: #FFFFFF;
//   line-height: 44px;
// }
// .el-pagination.is-background .el-pager li {
//   min-width: 44px;
//   width: auto;
//   height: 44px;
//   border-radius: 10px;
//   border: 1px solid #E5E5E5;
//   background: transparent;
//   font-size: 14px;
//   font-weight: 400;
//   color: #9A9A9A;
//   line-height: 44px;
// }
// .el-pagination {
//   display: flex;
//   justify-content: flex-end;
//   margin-top: 30px;
// }
.el-pagination__jump {
  margin-left: 0px;
}
// /**element table */
// .el-table {
//   background: transparent;
// }
.el-table::before {
  height: 0;
}
.el-table .el-table__header tr, .el-table .el-table__body tr {
  background: transparent!important;
}
.el-table .el-table__header th {
  line-height: 20px;
  height: 40px;
  padding: 0;
  background: #F6F6F6!important;
}
.el-table .el-table__header .cell{
  font-size: 14px;
  font-weight: normal;
  color: #333333;
}
.el-table .el-table__body td {
  line-height: 20px;
  height: 50px;
  padding: 0;
  background: transparent!important;
}
// .el-table .el-table__header th .icon, .el-table .el-table__body td .icon {
//   color: #999999;
//   font-size: 18px;
//   margin-right: 14px;
//   cursor: pointer;
// }
// .el-table .el-table__body .el-table__row--level-0 td {  // 一级table, 可以点开的，，，
//   background: transparent!important;
//   border-bottom: 2px solid #F7F7F7;
// }
// .el-table .el-table__body tr:hover {
//   box-shadow: 0px 0px 10px 0px rgba(228, 228, 228, 0.5);
// }
// .el-table .el-table__body tr:hover>td {
//   border-bottom: 0;
// }
// .el-table--enable-row-hover .el-table__body-wrapper .el-table__body .el-table__row--level-0:hover>td {   // 一级table
//   box-shadow: 0 0px 0px #ccc;
//   border-radius: 0;
//   border-bottom: 2px solid #F7F7F7;
// }
// .el-table--enable-row-hover .el-table__body tr:hover>td .el-icon-edit-outline, .el-table--enable-row-hover .el-table__body tr:hover>td .el-icon-circle-plus-outline {
//   color: #2461D9;
// }
// .el-table--enable-row-hover .el-table__body tr:hover>td .el-icon-remove-outline {
//   color: #FF754C;
// }
// .el-table .el-table__body .cell{
//   font-size: 14px;
//   font-weight: 400;
//   color: #333333;
// }
// // .el-table__expand-icon {
// //   transform-origin: 10px 10px;
// //   margin-right: 11px!important;
// //   width: 20px;
// //   height: 20px;
// //   line-height: 20px;
// //   text-align: center;
// // }
// // .el-table__expand-icon>.el-icon-arrow-right {
// //   position: static;
// //   color: #6D6D6D;
// //   margin: 0;
// //   padding: 2px;
// //   border: 1px solid #6D6D6D;
// //   box-sizing: border-box;
// //   border-radius: 9px;
// // }
// .el-textarea__inner {
//   resize: none;
// }
// /* 单选 */
// .el-radio__inner::after {
//   width: 5px;
//   height: 5px;
// }
// .el-radio__input .el-radio__inner {
//   border: 1px solid #A1A1B0;
// }
// .el-radio__input.is-checked .el-radio__inner {
//   border: none;
// }
// .el-radio__label .label {
//   font-size: 14px;
//   font-weight: 400;
//   color: #333333!important;
// }
// // .el-select .el-input__inner {
// //   vertical-align: bottom !important;
// // }
// .el-row{
//   margin: 0 !important;
// }

// .el-form--inline .el-form-item{
//   vertical-align: bottom;
// }
// .el-form-item {
//   margin-bottom: 30px;
// }
// .popper.el-tooltip__popper {
//   width: 310px;
// }
// .el-tooltip__popper {
//   max-width: 50%;
// }
// .last-el-form-item{
//   float: right;
//   padding-top: 28px;
//   margin-right: 0 !important;
// }
.el-message-box {
  border-radius: 8px 8px 8px 8px;
  padding-bottom: 30px;
  width: 457px;
  .el-message-box__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 10px 20px 6px 20px!important;
    height: 52px;
    box-sizing: border-box;
    border-bottom: 1px solid #F5F6F5;
    .el-message-box__title {
      font-size: 16px;
      color: #333;
    }
    // .el-message-box__headerbtn {
    //   position: static;
    //   .el-icon-close::before{
    //     content: '关闭';
    //     width: 72px;
    //     height: 36px;
    //     display: inline-block;
    //     border-radius: 6px 6px 6px 6px;
    //     opacity: 1;
    //     border: 1px solid #F0F0F0;
    //     color: #666666;
    //     line-height: 36px;
    //     font-size: 14px;
    //   }
    // }
  }
  .el-message-box__content {
    padding: 30px 30px 0 30px;
    .el-message-box__status {
      display: none;
    }
    .el-message-box__message {
      padding: 0;
      font-size: 16px;
      color: #333;
      text-align: center;
      p {
        display: inline-block;
        text-align: left;
      }
    }
  }
  .el-message-box__btns {
    display: flex;
    justify-content: center;
    padding: 0;
    align-items: center;
    flex-direction: row-reverse;
    margin-top: 50px;
    padding: 0 30px;
    .el-button {
      width: 140px;
      margin-left: 16px;
      padding: 11px 0;
      font-size: 14px;
    }
    .el-button:last-child {
      margin: 0;
    }
  }
}
// // 图片预览关闭按钮
// .el-image-viewer__close{
//   top: 60px;
// }

// .df{
//   display: flex;
// }
// .al-it{
//   align-items: center;
// }
// .jc-end{
//   justify-content: flex-end;
// }

// // 文字超出部分...
// .over-text-1{
//   overflow:hidden;
//   white-space:nowrap;
//   text-overflow:ellipsis;
// }
// .over-text-2{
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-line-clamp: 2;
//   word-break: break-all;  // 注意这个文字多行很重要
//   -webkit-box-orient: vertical;
// }
// // 文本提示
// .el-tooltip__popper {
//   background: #fff!important;
//   border: 1px solid #303133!important;
//   color: #303133!important;
//   line-height: 1.5!important;
// }
// .custom-popper{
//   width: 514px;
//   border: none !important;
//   padding: 0 !important;
//   background: #FFFFFF;
//   box-shadow: 3px 3px 6px 1px rgba(0, 0, 0, 0.16);
//   opacity: 1;
// }

// .custom-popper .popper__arrow {
//     border: none;
//     top: 25px !important;
//     left: -20px !important;
// }

// .custom-popper .popper__arrow::after {
//   border-width: 10px !important;
// }
// // .filter-box{
// //   .el-form--inline{
// //     display: flex;
// //     .el-form-item{
// //       max-width: 240px !important;
// //       width: 100%;
// //       &:last-child{
// //         margin-left: auto;
// //         width: auto !important;
// //       }
// //     }
// //     .el-input{
// //       width: 100% !important;
// //     }
// //     // .last-el-form-item{

// //     // }
// //   }
// // }
@media (min-width: 1980px) {
  html {
    /* 在窗口宽度小于等于 600px 时应用的样式 */
    font-size: 199.4px;
  }
}
</style>
